// Where an admin opens a Case in the telehealth vendor (MDI) (XCUT-R23).
export const telehealthCaseUrl = (caseId: string) =>
  `https://app.mdintegrations.com/tabs/cases/${caseId}`;

// Where an admin opens a User's clinic profile in the telehealth vendor (MDI): its search for the
// patient ID (USER-R38).
export const telehealthPatientUrl = (patientId: string) =>
  `https://app.mdintegrations.com/tabs/search?search=${encodeURIComponent(patientId)}`;
